import { createApi } from '@reduxjs/toolkit/query/react';

import {
  IReplyCustomerRequestData,
  IRequestCategoryInfo,
  IRequestCreateRequest,
  IRequestCreateResponse,
  IRequestDetailsRequest,
  IRequestDetailsResponse,
  IRequestListRequest,
  IRequestListResponse,
} from '@/interfaces/requests';

import { baseQueryWithReauth } from './baseQuery';

export const requestsApi = createApi({
  reducerPath: 'requestsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getRequestList: builder.query<IRequestListResponse, IRequestListRequest>({
      query: (data) => ({
        url: `requests/get?per_page=10&page=${data.page}`,
        method: 'GET',
      }),
    }),
    getRequestDetails: builder.query<
      IRequestDetailsResponse,
      IRequestDetailsRequest
    >({
      query: (data) => ({
        url: `requests/getDetail/${data.id}`,
        method: 'GET',
      }),
    }),
    createRequest: builder.mutation<
      IRequestCreateResponse,
      IRequestCreateRequest
    >({
      query: (data) => {
        const formData = new FormData();
        formData.append('title', data.title);
        formData.append('category_id', String(data.category_id));

        if (data?.description) {
          formData.append('description', data.description);
        }

        data?.files?.map((file: File) => {
          formData.append('files[]', file);
        });

        return {
          url: 'requests/store',
          method: 'POST',
          body: formData,
        };
      },
    }),
    customerReply: builder.mutation<
      IRequestCreateResponse,
      IReplyCustomerRequestData
    >({
      query: (data) => {
        const formData = new FormData();
        formData.append('request_id', String(data.request_id));
        if (data.text) formData.append('text', data.text);
        data?.files?.forEach((file: File) => {
          formData.append('files[]', file);
        });
        if (data.signature) {
          formData.append('signature', data.signature);
        }
        if (data.mchd) {
          formData.append('mchd', data.mchd);
        }

        return {
          url: `requests/customer-reply`,
          method: 'POST',
          body: formData,
        };
      },
    }),
    getRequestCategory: builder.query<Array<IRequestCategoryInfo>, void>({
      query: () => ({
        url: `requests/getCategories`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetRequestListQuery,
  useGetRequestDetailsQuery,
  useCreateRequestMutation,
  useCustomerReplyMutation,
  useGetRequestCategoryQuery,
} = requestsApi;
